import React from "react";
import { useSelector } from "react-redux";

import { Utilities } from "@learningblocks/exp-constants";
const { COMPONENT_TYPE } = Utilities;

import { RichText } from "@learningblocks/shared-components/lib/RichText";
import GelPredictions512 from "@learningblocks/protocol-components/lib/GelPredictions512";

export const ConditionalDisplay = (props) => {
  const condition_component = useSelector(
    (state) =>
      state[props.conditionalComponent.type][props.conditionalComponent.id]
  );

  const displayComponent = () => {
    if (props.conditionalComponent.condition.type == "onSubmit") {
      if (condition_component && condition_component.disabled) {
        return props.conditionalComponent.condition.display;
      }
    }
    return props.conditionalComponent.condition.defaultDisplay;
  };

  const renderComponent = () => {
    switch (props.component.type) {
      case COMPONENT_TYPE.PLAIN_TEXT:
        return <RichText key={props.id} {...props.component} />;
      case COMPONENT_TYPE.GEL_PREDICTIONS_512:
        return <GelPredictions512 key={props.id} {...props.component} />;
    }
  };

  return <div hidden={!displayComponent()}>{renderComponent()}</div>;
};
